import React from 'react'

export default (props) =>
    <svg {...props} width="9" height="1425" viewBox="0 0 9 1425" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4.5" cy="4.5" r="4" stroke="#7DDE8B"/>
        <circle cx="4.5" cy="153.5" r="4" stroke="#7DDE8B"/>
        <path d="M4.4 149V8.75" stroke="#7DDE8B"/>
    </svg>